import { useEffect, useState } from "react";
import { R1CadPcf } from "../reports/R1CadPcf";
import { MsgModal } from "../components/MsgModal";

// atcadpcf / IMPRIMIR (e pcf_etapas do apontamento) — R1CADPCF idêntico ao Jasper do legado:
// mesma consulta (servidor) + layout extraído do .jrxml (reports/r1cadpcf.json).

interface Props {
  numpcf: number;
  onVoltar: () => void;
  // Estação de apontamento (sem login) carrega pela rota pública.
  carregar?: (numpcf: number) => Promise<Record<string, unknown>[]>;
}

async function carregarPadrao(numpcf: number): Promise<Record<string, unknown>[]> {
  const token = localStorage.getItem("formsteel-token");
  const r = await fetch(`/api/pcf/${numpcf}/r1cadpcf`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!r.ok) throw new Error(`Falha ao carregar a PCF (HTTP ${r.status}).`);
  return r.json();
}

export async function carregarR1Publico(numpcf: number): Promise<Record<string, unknown>[]> {
  const r = await fetch(`/api/apontamento/r1cadpcf/${numpcf}`);
  if (!r.ok) throw new Error(`Falha ao carregar a PCF (HTTP ${r.status}).`);
  return r.json();
}

export function PcfImpressao({ numpcf, onVoltar, carregar }: Props) {
  const [linhas, setLinhas] = useState<Record<string, unknown>[] | null>(null);
  const [erro, setErro] = useState<string | null>(null);

  useEffect(() => {
    void (async () => {
      try {
        const l = await (carregar ?? carregarPadrao)(numpcf);
        if (!l.length) setErro("PCF sem etapas no roteiro — o relatório do legado não imprime PCF sem etapas.");
        setLinhas(l);
      } catch (e) {
        setErro((e as Error).message);
      }
    })();
  }, [numpcf, carregar]);

  return (
    <div className="pcf-print-wrap">
      <div className="pcf-print-toolbar">
        <button className="btn-secundario" onClick={onVoltar}>
          ← Voltar
        </button>
        <button className="btn-acao" disabled={!linhas?.length} onClick={() => window.print()}>
          Imprimir
        </button>
      </div>
      {linhas === null && !erro && <div className="status-loading">Carregando…</div>}
      {linhas && <R1CadPcf linhas={linhas} />}
      <MsgModal texto={erro} tipo="erro" onClose={() => (linhas?.length ? setErro(null) : onVoltar())} />
    </div>
  );
}
